import { callFunctionIfExists } from "../../utils/GeneralUtils";

const IconCardSmall = ({
  icon,
  name,
  isSelected,
  isDisabled,
  iconOutline,
  onClick,
  css = "",
}: {
  icon: `mdi mdi-${string}`;
  name: string;
  isSelected: boolean;
  isDisabled: boolean;
  iconOutline: boolean;
  onClick?: () => void;
  css: string;
}) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        callFunctionIfExists(onClick);
      }}
      className={css || ""}
    >
      <div className="w-100 bg-primary-selected--hover  d-flex align-items-center cursor-pointer rounded border border-superlight btn-oauth">
        <div
          className={`${
            iconOutline
              ? isSelected
                ? " border border-dropdown-selected-dark"
                : " border border-superlight"
              : ""
          } ml-2 mr-3 px-2 py-2 rounded-sm ${iconOutline ? "bg-white" : ""}`}
          style={{ position: "relative" }}
        >
          <i className={icon} style={{ fontSize: 20 }} />
        </div>
        <div className="w-100 d-flex justify-content-between align-items-center">
          <h3 className="mb-0 pr-4" style={{ fontSize: 15 }}>
            {name}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default IconCardSmall;
